import { render, staticRenderFns } from "./EUServicesList.vue?vue&type=template&id=e24f7ef4&scoped=true&"
import script from "./EUServicesList.vue?vue&type=script&lang=js&"
export * from "./EUServicesList.vue?vue&type=script&lang=js&"
import style0 from "./EUServicesList.vue?vue&type=style&index=0&id=e24f7ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24f7ef4",
  null
  
)

export default component.exports